<template>
  <v-dialog :model-value="modelValue" @update:model-value="close" width="560" persistent>
    <v-card v-if="modelValue">
      <v-card-title class="d-flex align-center">
        <span>{{ edited ? $t('labelOrder.dialog.approveEditedTitle') : $t('labelOrder.dialog.approveTitle') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon variant="text" density="comfortable" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-alert
          :type="edited ? 'warning' : 'success'"
          variant="tonal"
          density="compact"
          class="mb-4"
          :text="edited ? $t('labelOrder.dialog.approveEditedText', [changedCount]) : $t('labelOrder.dialog.approveText')"
        />
        <v-alert v-if="errorMessage" type="error" density="compact" class="mb-4" :text="errorMessage" />

        <DatePicker v-model="deliveryDate" :label="$t('labelOrder.label.deliveryDate') + ' *'" />
        <div class="text-caption text-medium-emphasis mt-1 mb-4">{{ $t('labelOrder.label.deliveryDateNote') }}</div>

        <v-textarea
          v-model="reviewNote"
          :label="$t('labelOrder.label.approveComment')"
          :placeholder="$t('labelOrder.label.approveCommentPlaceholder')"
          variant="outlined"
          density="compact"
          rows="2"
          auto-grow
          hide-details="auto"
          counter="500"
        />

        <v-sheet class="d-flex mt-4 pa-3 bg-grey-lighten-4 rounded">
          <div class="mr-8">
            <div class="text-caption text-medium-emphasis">{{ $t('labelOrder.label.summary.approvedTotal') }}</div>
            <div class="text-h6 text-blue-darken-2">{{ num(approvedTotal) }} {{ $t('labelOrder.label.unitSheet') }}</div>
          </div>
          <div>
            <div class="text-caption text-medium-emphasis">{{ $t('labelOrder.label.summary.targetStores') }}</div>
            <div class="text-h6">{{ lineCount }} {{ $t('labelOrder.label.unitStore') }}</div>
          </div>
        </v-sheet>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="close">{{ $t('labelOrder.action.back') }}</v-btn>
        <v-btn
          :class="edited ? 'bg-amber-darken-2' : 'bg-green-darken-1'"
          class="px-6"
          elevation="2"
          :loading="isSubmitting"
          @click="submit"
        >{{ edited ? $t('labelOrder.action.doApproveEdited') : $t('labelOrder.action.doApprove') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="js">
import DatePicker from "@/components/DatePicker";
import api from "@/apis/staff";
import { num } from "@/utils/labelManagement";

/**
 * ラベル発注申請の承認ダイアログ（申請どおりに承認 / 修正して承認）。
 * 承認に成功すると approved を発行する（引数は納品予定日）。
 */
export default {
  components: { DatePicker },
  props: {
    modelValue: Boolean,
    requestId: String,
    // true: 修正して承認（lines の確定枚数で承認する）
    edited: Boolean,
    // 修正して承認するときの確定枚数 [{ siteCode, qty }]
    lines: { type: Array, default: null },
    changedCount: { type: Number, default: 0 },
    approvedTotal: { type: Number, default: 0 },
    lineCount: { type: Number, default: 0 },
  },
  emits: ["update:modelValue", "approved"],
  data: () => ({
    deliveryDate: "",
    reviewNote: "",
    errorMessage: "",
    isSubmitting: false,
  }),
  watch: {
    modelValue(open) {
      if (open) {
        this.deliveryDate = "";
        this.reviewNote = "";
        this.errorMessage = "";
      }
    },
  },
  methods: {
    num,
    close() {
      if (this.isSubmitting) return;
      this.$emit("update:modelValue", false);
    },
    submit() {
      this.isSubmitting = true;
      this.errorMessage = "";
      api.post("/label-order/approve", {
        requestId: this.requestId,
        deliveryDate: this.deliveryDate || null,
        reviewNote: this.reviewNote || null,
        lines: this.edited ? this.lines : null,
      })
        .then((response) => {
          if (response.data?.status == 1) {
            this.errorMessage = response.data.errorMessage;
            return;
          }
          const deliveryDate = this.deliveryDate;
          this.$emit("update:modelValue", false);
          this.$emit("approved", deliveryDate);
        })
        .catch(() => {
          this.errorMessage = this.$t("common.message.error") || "Error";
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
